export const visit = (vm, at) => {
at({ "ja": { "ui-addon-video-player": { "havingTroubleWithVideoLink": "\u52D5\u753B\u306E\u518D\u751F\u3067\u4F55\u304B\u554F\u984C\u304C\u3042\u308A\u307E\u3059\u304B\uFF1F", "playButton": "\u518D\u751F" } } });
};